<div *ngIf="isBlocking">

    <div class="map-block"></div>

    <div class="message-container">
        <h2>{{ message }}</h2>
        <div class="loading">
            <span class="dot animation1"></span> <span class="dot animation2"></span> <span class="dot animation3"></span>
        </div>
    </div>
</div>
